import React, { useState } from 'react';
import { X, Copy, Check } from 'lucide-react';
import '../../../styles/pages/alerts.css';
import '../../../styles/pages/help-support.css';

interface TicketSuccessModalProps {
  isOpen: boolean;
  refNumber: string;
  onClose: () => void;
}

const TicketSuccessModal: React.FC<TicketSuccessModalProps> = ({ isOpen, refNumber, onClose }) => {
  const [copied, setCopied] = useState(false);

  if (!isOpen) return null;

  const handleCopy = () => {
    navigator.clipboard.writeText(refNumber);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="modal-overlay zoomOutLevel" onClick={onClose}>
      <div className="modal-content" style={{ maxWidth: 420 }} onClick={(e) => e.stopPropagation()}>

        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '16px 16px 0' }}>
          <button className="modal-close" onClick={onClose}><X size={20} /></button>
        </div>

        <div className="modal-form" style={{ paddingTop: 0 }}>
          {/* Success icon */}
          <div className="hs-success-icon">
            <img src={`${process.env.PUBLIC_URL}/SVGIcons/TickMarkIcon.svg`} alt="Success Icon" />
          </div>

          <h2 className="hs-success-title">Ticket Submitted Successfully!</h2>
          <p className="hs-success-subtitle">
            Your support ticket has been raised and assigned the following reference number:
          </p>

          {/* Ref number box */}
          <div className="hs-ref-box">
            <p className="hs-ref-label">Ticket Reference Number</p>
            <div className="hs-ref-row">
              <span className="hs-ref-number">{refNumber}</span>
              <button className="hs-copy-btn" onClick={handleCopy} title="Copy">
                {copied ? <Check size={16} /> : <Copy size={16} />}
              </button>
            </div>
          </div>

          {/* Notice */}
          <div className="hs-success-notice">
            Our support team will review your ticket and reach out to you within{' '}
            <strong>2–3 business days.</strong>
          </div>

          <p className="hs-success-footer-note">
            Please save this reference number for future correspondence regarding your ticket.
          </p>
        </div>

        <div className="modal-actions">
          <button className="modal-button primary" onClick={onClose}>Done</button>
        </div>

      </div>
    </div>
  );
};

export default TicketSuccessModal;
